import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractCrudService } from '../../../shared/components/crud/abstract-crud.service';
import { API_PATH } from 'src/environments/environment';
import { RELATIVE_URL } from './crud-config';
import { GlobalUtils } from '../../../shared/global-utils';

@Injectable()
export class ServiceOrderService extends AbstractCrudService {

  constructor(protected override httpClient: HttpClient) {
    super(httpClient, RELATIVE_URL);
  }
  getServiceOrderDetails(orderId: string): Observable<any> {
    return this.httpClient.get<any>(`${API_PATH}service-orders/${orderId}`);
  }

  generatePaymentCharge(body: { fileType: string; customerId?: string; chargeCustomerId?: string; partnerId?: string }): Observable<any> {
    return this.httpClient.post<any>(`${API_PATH}service-orders/payment-charge`, body);
  }

  getPaymentCharge(id: string): Observable<{ viewerUrl: string; slipId?: string }> {
    return this.httpClient.get<{ viewerUrl: string; slipId?: string }>(
      `${API_PATH}service-orders/${id}/payment-charge`
    );
  }

  getStatistics(): Observable<any> {
    return this.httpClient.get<any>(`${API_PATH}service-orders/statistics`);
  }

  getServiceOrderVersions(orderId: string): Observable<any[]> {
    return this.httpClient.get<any[]>(`${API_PATH}service-orders/${orderId}/versions`);
  }

  updateCancelReason(id: string, cancelReason: string): Observable<any> {
    return this.httpClient.put(`${API_PATH}${this.relativeUrl}/${id}/cancel-reason`, { cancelReason });
  }

  changeStatus(id: string, status: string): Observable<any> {
    return this.httpClient.put(`${API_PATH}${this.relativeUrl}/${id}/status`, { status });
  }

  getServiceOrderPdfUrl(id: string): Observable<{ url: string; title: string; code: number }> {
    return this.httpClient.get<{ url: string; title: string; code: number }>(`${API_PATH}${this.relativeUrl}/${id}/pdf`);
  }

  getAttachmentUrl(key: string): Observable<{ url: string }> {
    return this.httpClient.get<{ url: string }>(
      `${API_PATH}${this.relativeUrl}/attachment-url`,
      { params: { key } }
    );
  }

  getAttachmentDownloadUrl(key: string): Observable<{ url: string }> {
    return this.httpClient.get<{ url: string }>(
      `${API_PATH}${this.relativeUrl}/attachment-url`,
      { params: { key, download: 'true' } }
    );
  }

  uploadSharePdf(id: string, file: Blob): Observable<{ url: string; title: string; code: number }> {
    const formData = new FormData();
    formData.append('file', file, `os-${id}.pdf`);
    return this.httpClient.post<{ url: string; title: string; code: number }>(
      `${API_PATH}${this.relativeUrl}/${id}/share-pdf`,
      formData,
    );
  }


  public findByName(name: string): Observable<Object> {
    return this.httpClient.get<Object>(
      `${API_PATH}${this.relativeUrl}/byName/${name}`
    );
  }

  public findByPartner(id: any): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${API_PATH}${this.relativeUrl}/byPartner/${id}`
    );
  }

  findBySystem(id: any) {
    return this.httpClient.get<any[]>(
      `${API_PATH}${this.relativeUrl}/bySystem/${id}`
    );
  }

  public findByPartnerTypeAndSystemAndCustomer(
    partnerId: any,
    type: number,
    systemId: any,
    systemsExternalId: any,
    customers: any
  ): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${API_PATH}${this.relativeUrl}/ByPartnerTypeAndSystemAndCustomer/${partnerId}/${type}/${systemId}/${systemsExternalId}/${customers}`
    );
  }

  getChatMessages(serviceOrderId: string): Observable<any[]> {
    return this.httpClient.get<any[]>(`service-order-chats/${serviceOrderId}`);
  }

  sendChatMessage(serviceOrderId: string, message: { user: string; text: string }): Observable<any> {
    return this.httpClient.post(`service-order-chats/${serviceOrderId}`, message);
  }

  findByTypeAndSystem(type: number, id: any) {
    return this.httpClient.get<any[]>(
      `${API_PATH}${this.relativeUrl}/byTypeAndSystem/${type}/${id}`
    );
  }

  updateWithReason(id: string, formData: FormData): Observable<any> {
    return this.httpClient.put(
      `${API_PATH}${this.relativeUrl}/${id}`,
      formData
    );
  }


  public findByFilter(filterForm: any, pagination: any): Observable<any[]> {
    let params = {
      ...{ getRelation: 0, limit: 36, page: 0, filter: '' },
      ...pagination,
    };

    return this.httpClient.post<any[]>(
      `${API_PATH}${this.relativeUrl}/filter`,
      { ...filterForm, ...params }
    );
  }

  public changeActiveStatus(userId: string, isActive: boolean) {
    return this.httpClient.put(
      `${API_PATH}${this.relativeUrl}/change-status/${userId}`,
      { isActive }
    );
  }

}
